// extracted by mini-css-extract-plugin
export default {"swiper":"ProductsCarousel_swiper__LCjcd","doubleEqualHeight":"ProductsCarousel_doubleEqualHeight__tYcFS","productSubcategory":"ProductsCarousel_productSubcategory__-1JIg"};